<template>
  <div>
    <v-alert
      type="info"
      class="mt-0"
    >
      <template v-if="$props.isReport">
        {{ 'v2.fm2.alert.rules.report-info'|trans }}
      </template>
      <template v-else>
        {{ 'v2.fm2.alert.rules.user-info'|trans }}
      </template>
    </v-alert>
    <v-autocomplete
      v-model="value"
      :items="users"
      :multiple="true"
      chips
      small-chips
      deletable-chips
      item-text="name"
      item-value="id"
      :label="$trans('v2.fm2.report.field.users')"
      @input="emitInput"
    />
  </div>
</template>

<script>
export default {
  props: {
    users: {
      required: true,
      type: Array,
    },
    value: {
      required: true,
      type: Array,
    },
    isReport: {
      required: false,
      type: Boolean,
    },
  },
  computed: {
    usersIds() {
      return this.value.map((group) => group.id);
    },
  },
  methods: {
    emitInput(usersIds) {
      const items = usersIds.map((id) => this.users.find((item) => item.id === id));
      this.$emit('input', items);
    },
  },
};
</script>
